module.exports = __webpack_public_path__ + "img/bca.c5d0fc95.svg";